/* src/app/person-search-listing/add-candidate-aegis-modal/add-candidate-aegis-modal.component.scss */
.add-aegis-modal {
  font-family:
    "Poppins",
    "Segoe UI",
    sans-serif;
  color: #29343d;
}
.add-aegis-modal .custom-header {
  align-items: flex-start;
  border-bottom: 1px solid #e8ecef;
  padding: 18px 20px 12px;
}
.add-aegis-modal .custom-header .title {
  margin: 0;
  color: #2d3a42;
  font-size: 16px;
  line-height: 100%;
  font-weight: 600;
  letter-spacing: 0;
}
.add-aegis-modal .custom-header .subtitle {
  margin: 10px 0 0;
  color: #8b97a2;
  font-size: 11px;
  line-height: 1.2;
  font-weight: 400;
}
.add-aegis-modal .custom-header .btn-close {
  margin: 4px 0 0 auto;
  opacity: 0.85;
  transform: scale(1.05);
}
.add-aegis-modal .custom-body {
  padding: 16px 20px 12px;
}
.add-aegis-modal .search-box {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 46px;
  padding: 0 14px;
  border: 2px solid #dbe3e8;
  border-radius: 8px;
  background: #ffffff;
}
.add-aegis-modal .search-box .search-icon {
  position: relative;
  width: 16px;
  height: 16px;
  border: 2px solid #98a4ae;
  border-radius: 50%;
  flex: 0 0 auto;
}
.add-aegis-modal .search-box .search-icon::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 2px;
  background: #98a4ae;
  border-radius: 2px;
  transform: rotate(42deg);
  right: -6px;
  bottom: -2px;
}
.add-aegis-modal .search-box input {
  border: 0;
  outline: 0;
  width: 100%;
  color: #969696;
  font-size: 12px;
  font-weight: 500;
  background: transparent;
  pointer-events: auto;
}
.add-aegis-modal .all-jobs-label {
  margin: 14px 0 10px;
  color: #303e47;
  font-size: 18px;
  font-weight: 700;
}
.add-aegis-modal .job-list {
  max-height: 470px;
  overflow-y: auto;
  padding-right: 8px;
}
.add-aegis-modal .job-list::-webkit-scrollbar {
  width: 8px;
}
.add-aegis-modal .job-list::-webkit-scrollbar-track {
  background: transparent;
}
.add-aegis-modal .job-list::-webkit-scrollbar-thumb {
  background: #9ea8b1;
  border-radius: 20px;
}
.add-aegis-modal .job-list__placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 260px;
  gap: 16px;
  padding: 24px 0;
  text-align: center;
}
.add-aegis-modal .job-item {
  display: flex;
  align-items: center;
  gap: 14px;
  border-radius: 8px;
  padding: 14px 14px;
  margin-bottom: 2px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.add-aegis-modal .job-item:hover {
  background: #e6eef1;
}
.add-aegis-modal .job-item .job-radio {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #31b2bf;
  background: #ffffff;
  flex: 0 0 auto;
}
.add-aegis-modal .job-item .job-content {
  min-width: 0;
}
.add-aegis-modal .job-item .job-title {
  margin: 0;
  color: #3c4952;
  font-size: 12px;
  line-height: 1.12;
  font-weight: 500;
  letter-spacing: 0;
}
.add-aegis-modal .job-item .job-meta {
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8f99a3;
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.add-aegis-modal .job-item .job-meta .meta-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: #9fa7af;
  opacity: 0.75;
}
.add-aegis-modal .job-item .job-meta .meta-icon.briefcase {
  border-radius: 2px;
}
.add-aegis-modal .job-item .job-meta .meta-icon.location {
  border-radius: 50%;
  width: 11px;
  height: 11px;
}
.add-aegis-modal .job-item .job-meta .meta-icon.company {
  border-radius: 0;
}
.add-aegis-modal .job-item .job-meta .meta-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #afb6bc;
  display: inline-block;
}
.add-aegis-modal .job-item.selected {
  background: #d4e0e4;
}
.add-aegis-modal .job-item input[type=radio] {
  cursor: pointer;
}
.add-aegis-modal .pagination-row {
  margin: 12px 0 0;
  display: flex;
  justify-content: center;
}
.add-aegis-modal .pagination-row ::ng-deep .pagination {
  margin: 0;
  gap: 10px;
}
.add-aegis-modal .pagination-row ::ng-deep .page-item .page-link {
  width: 36px;
  height: 36px;
  border: 1px solid #e4eaee;
  background: #ffffff;
  border-radius: 7px;
  color: #73808a;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: none;
}
.add-aegis-modal .pagination-row ::ng-deep .page-item.active .page-link {
  background: #2cb0be;
  border-color: #2cb0be;
  color: #ffffff;
}
.add-aegis-modal .pagination-row ::ng-deep .page-item.disabled .page-link {
  color: #96a2ab;
  opacity: 0.6;
}
.add-aegis-modal .custom-footer {
  border-top: 0;
  padding: 14px 20px 20px;
  gap: 12px;
}
.add-aegis-modal .custom-footer .btn-cancel,
.add-aegis-modal .custom-footer .btn-submit {
  height: 50px;
  border: 0;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 18px;
  font-weight: 600;
  min-width: 118px;
}
.add-aegis-modal .custom-footer .btn-cancel {
  background: #dff0f3;
  color: #2f9daa;
}
.add-aegis-modal .custom-footer .btn-submit {
  min-width: 180px;
  background: #bfe5eb;
  color: #ffffff;
  opacity: 0.9;
  cursor: not-allowed;
}
@media (max-width: 992px) {
  .add-aegis-modal .custom-header .title {
    font-size: 26px;
  }
  .add-aegis-modal .custom-header .subtitle {
    font-size: 18px;
  }
  .add-aegis-modal .job-item .job-title {
    font-size: 14px;
  }
}
@media (max-width: 600px) {
  .add-aegis-modal .custom-header,
  .add-aegis-modal .custom-body,
  .add-aegis-modal .custom-footer {
    padding-left: 14px;
    padding-right: 14px;
  }
  .add-aegis-modal .job-item {
    gap: 10px;
    padding: 12px 10px;
  }
  .add-aegis-modal .job-item .job-title {
    font-size: 14px;
  }
  .add-aegis-modal .job-item .job-meta {
    font-size: 12px;
    gap: 6px;
  }
  .add-aegis-modal .custom-footer .btn-cancel,
  .add-aegis-modal .custom-footer .btn-submit {
    height: 44px;
    font-size: 16px;
  }
  .add-aegis-modal .custom-footer .btn-submit {
    min-width: 145px;
  }
}
.btn-trms-medium.bg-gray {
  background-color: #969696 !important;
  color: #fff !important;
  border: 0px !important;
}
/*# sourceMappingURL=add-candidate-aegis-modal.component-UPTKUBZL.css.map */
